// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// Service
import { BroadcastService } from '@cv-invision/core';
import { SchemasService } from '../services/schemas.service';
import { ViewsService } from '../services/views.service';
import { Lightbox } from 'ngx-lightbox';
import { CVfUtilsService } from '../open-schema/services/cvf-utils.service';
// Model
import { ROOM_POSITION } from '../sections-review/models/cvds/v3.3/room.layout';
import { BroadcastEventModel } from '@cv-invision/core';
import { SCHEMA_TYPE } from '../models/enums.model';
// Other
import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

// Deprecated
export const EVENT_MENU_SELECTED_LEVEL = 'eventMenuSelectedLevel';

export const CHANGE_SKETCH_IMAGE = 'eventSketchChangeImage';

@Component({
	selector: 'cv-floating-sketch',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './floating-sketch.component.html',
	styleUrls: ['./floating-sketch.component.scss']
})
export class FloatingSketchComponent implements OnInit, OnDestroy {
	// Status of the Show Sketch
	public open = true;
	public levelName = '';
	public sectionSelected = '';
	public currentSketch = '';
	// Information from the Order and Document
	get photos(): any {
		return this.viewsServices.photos;
	}
	// All Photo Selected
	get photosSelected(): any {
		return this.viewsServices.photosSelected;
	}
	// List of Selected Sketch
	public selectedSketch = [];
	public selectedLevelPath = '';
	// Album
	public album = [];
	// Broadcast instance
	private atComponentDestroy = new Subject();

	constructor(
		private broadcastService: BroadcastService,
		private cvfUtils: CVfUtilsService,
		private schemasS: SchemasService,
		private lightbox: Lightbox,
		private viewsServices: ViewsService)
	{
		const schemasShouldBClosed = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString()
		];

		this.open = schemasShouldBClosed.indexOf(this.viewsServices.order.schema) === -1;
	}

	/**
	 * Initialize the Sketch with the First Level Selected
	 */
	async ngOnInit(): Promise<void> {
		// Listen to select an Item
		this.broadcastService
			.onEvent(CHANGE_SKETCH_IMAGE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((e: BroadcastEventModel) => {
				const {event: {data}} = e;
				if (data.removeSketch) {
					this.selectedSketch = [];
				} else {
					const roomPosition = (data.room && data.room.position && data.room.position.toLowerCase()) || '';
					const levelPath = (data.level && data.level._Path) || '';
					if (roomPosition === ROOM_POSITION.INTERIOR.toLowerCase()) {
						if (this.sectionSelected !== levelPath) {
							this.selectedLevelPath = levelPath;
							this.loadSketch(data);
						}
					} else {
						this.selectedSketch = [];
					}
				}
			});
	}

	/**
	 * Load the Menu and listen for changes if necessary
	 * @private
	 */
	private loadSketch(data: any): void {
		this.album = [];
		this.selectedSketch = [];
		// tslint:disable-next-line:max-line-length
		const sketchFiles = this.photos.filter((photo: any) => photo.metadata && photo.metadata.type === 'SKETCH' && photo.refJsonPath === data.level._Path) || [];

		if (sketchFiles.length > 0) {
			let matchToPush = sketchFiles[0];
			const sketchFilesGLA = sketchFiles.filter(photo => photo.metadata.imageType === 'GLA') || [];

			if (sketchFilesGLA.length > 0) {
				matchToPush = sketchFilesGLA[0];
			}

			this.album.push({
				src: matchToPush.path,
				caption: '',
				thumb: ''
			});
			this.selectedSketch.push(matchToPush);
		}

		this.levelName = data.level.cv_Label || data.level.name;
	}

	/**
	 * Open/Show the  sketch image
	 * @param $event
	 */
	public openSketch($event: any): void {
		this.open = !this.open;
	}

	/**
	 * Expand the photo
	 * @param $event
	 */
	public expandPhoto($event: any): void {
		// console.log(this.selectedSketch);
		if (this.selectedSketch[0]) {
			const image = {
				src: this.selectedSketch[0].path,
				caption: '',
				thumb: ''
			};
			this.lightbox.open([image], 0);
		}
	}

	/**
	 * Open Current Photo but keep the Album
	 * @param data
	 */
	public openGallery(data: any): void {
		// console.log(data, this.selectedSketch, this.album);

		if (data.photo) {
			const image = {
				src: data.photo.path,
				caption: '',
				thumb: ''
			};
			this.lightbox.open([image], 0);
		}
	}

	/**
	 * * Mark or not the Sketch Photo
	 * @param event HTML Input Change Event
	 * @param image from the array of images
	 */
	public onCheckSketch(event: any, image: any): void {
		const photoIndex = this.photosSelected.indexOf(image.id);
		if (photoIndex > -1) {
			this.photosSelected.splice(photoIndex, 1);
		} else {
			this.photosSelected.push(image.id);
		}
	}

	/**
	 * Return if the image is on the photo selected method
	 * @param image from the array of images
	 */
	public isSketchSelected(image: any): boolean {
		return this.photosSelected.indexOf(image.id) >= 0;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
